import {
  Camera,
  DirectionsCar,
  EscalatorWarning,
  Face,
  Mood,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import ImageModalComponent from 'components/ImageModalComponent';
import TableComponent, { IColumnProps } from 'components/TableComponent';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import {
  EVENT_ENDPOINT,
  getAllStreamCountByLicenseAsync,
  getStreamByEndpointAsync,
} from 'services/Events';
import { EventDiscriminator } from 'services/Events/types';
import { IPaginationParams } from 'services/types';
import { transformDateStringInDate } from 'utils/TransformUtils';

const ListMonitoringPage = () => {
  const [events, setEvents] = useState<any[]>([]);
  const [isOpenImageModal, setIsOpenImageModal] = useState<boolean>(false);
  const [imageUrlToModal, setImageUrlToModal] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [lastEvent, setLastEvent] = useState();
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [totalCount, setTotalCount] = useState<number>(0);

  const columns: IColumnProps[] = [
    {
      id: 'discriminator',
      label: '',
      width: 'min',
      render: (val: any) => {
        return renderIconByEventType(val);
      },
    },
    { id: 'description', label: t('common.description'), width: '100%' },
    { id: 'device.name', label: t('common.device'), width: '100%' },
    {
      id: 'image',
      label: t('common.image'),
      align: 'center',
      width: '0%',
      render: (_, rowIndex) => {
        const event = events[rowIndex];
        const imageUrl =
          event.recognitionImage || event.carImage || event.image;
        return (
          <img
            width={300}
            onClick={() => handleClickImage(imageUrl)}
            src={imageUrl}
            alt="event_img"
            style={{ maxWidth: '70%', maxHeight: '70%', cursor: 'pointer' }}
          />
        );
      },
    },
    {
      id: 'createdAt',
      label: t('common.date'),
      width: '0%',
      render: (val) => <>{new Date(val).toLocaleString('pt-BR')}</>,
    },
  ];

  const renderIconByEventType = (val: EventDiscriminator) => {
    switch (val) {
      case 'IvsEventEntity':
        return <Camera color="warning" />;
      case 'LprEventEntity':
        return <DirectionsCar color="primary" />;
      case 'FaceRecognitionEventEntity':
        return <Mood color="success" />;
      case 'StudentRecognitionEventEntity':
        return <Face color="secondary" />;
      case 'ResponsibleRecognitionEventEntity':
        return <EscalatorWarning color="secondary" />;
    }
    return <></>;
  };

  const handleClickImage = (imageUrl: string) => {
    setImageUrlToModal(imageUrl);
    setIsOpenImageModal(true);
  };

  useEffect(() => {
    refetchEvents();
  }, [pagination]);

  const refetchEvents = async () => {
    await getStreamByEndpointAsync(
      EVENT_ENDPOINT,
      setEvents,
      pagination,
      undefined,
      setIsLoading,
    );
    getAllStreamCountByLicenseAsync(EVENT_ENDPOINT).then(setTotalCount);
  };

  useEffect(() => {
    if (events.length > 0) {
      const mostRecentEvent = events.reduce((latest, current) =>
        transformDateStringInDate(current.createdAt) >
        transformDateStringInDate(latest.createdAt)
          ? current
          : latest,
      );
      setLastEvent(mostRecentEvent);
    }
  }, [events]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: { md: '100%', xs: '99%' },
          paddingRight: '5px',
        }}
      >
        <TableComponent
          rows={events}
          sortByName={'createdAt'}
          columns={columns}
          totalCount={totalCount}
          isLoading={isLoading}
          onChangePageOrRowsPerPage={(param) => {
            setPagination(param);
          }}
          title={t('common.lastEvent')}
          margin={'0px'}
          height={'90%'}
          width={'100%'}
        />
      </Box>
      <ImageModalComponent
        isOpen={isOpenImageModal}
        handleClose={() => setIsOpenImageModal(false)}
        imageUrl={imageUrlToModal}
      />
    </>
  );
};

export default ListMonitoringPage;
